import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        margin: '10px 0',
    },
}));

export default useStyles;
